// store/index.js
// import _this from "@/main.js"
import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api/apis'
Vue.use(Vuex)
    // 引入本地存储的方法
export default new Vuex.Store({

    state: {
        cacheObj:{
            firstLoad:true,//第一次加载
            loading:true,//是否正在加载中
            finished:false,//是否到底部
            pagenum: 1,//当前页数
            total: 0,//总条数
            productList:[],//商品列表
            scollPostion:0,//首页的滚动条位置
        },
        token: localStorage.getItem('token'),
        userInfo:JSON.parse(localStorage.getItem('userInfo')) ||"",
        projectList:[],
        curProject:"",
        userId:"",
        name: "",
        roles:[],
        account: "",
        position:"",

        curGroup:"",
      
      
    },
    mutations: {
        clear(state) {
            state.token = ""
            state.account = ""
            state.name = ""
            state.userId = ""
            state.userInfo = {}
        },
        //储存是否是第一次加载的状态
        setCacheObjFirstLoad(state, payload){
            state.cacheObj.firstLoad = payload
        },
        //是否是正在加载中
        setCacheObjLoading(state, payload){
            state.cacheObj.loading = payload
        },
        //首页滚动条位置
        setCacheObjScollPostion(state, payload){
            state.cacheObj.scollPostion = payload
        },
        //是否到底部
        setCacheObjFinished(state, payload){
            state.cacheObj.finished = payload
        },
        //储存当前页数
        setCacheObjPagenum(state, payload){
            state.cacheObj.pagenum = payload
        },
        //储存当前条数
        setCacheObjTotal(state, payload){
            state.cacheObj.total = payload
        },
        
        //存储用户信息
        setUserInfo(state, payload) {
            state.userInfo = payload
            localStorage.setItem('userInfo', JSON.stringify(payload))
        },
        
        setToken(state, token) {
            state.token = token
            localStorage.setItem("token", token);
        },
        //设置用户名
        setAccount(state, payload) {
            state.account = payload
            // localStorage.setItem('username', JSON.stringify(payload))
        },
        setUserId(state, payload) {
            state.userId = payload
        },
      

        setName(state, payload) {
            state.name = payload
        },
        setPosition(state, payload) {
            state.position = payload
        },
        setCurProject(state, payload) {
            state.curProject = payload
        },
        setRoles(state, roles) {
            state.roles = roles
           
        },
        setProjectList(state, payload) {
            state.projectList = payload
           
        },
        
        
        


        getUserInfo(state, payload) {
            state.userInfo = payload
            localStorage.setItem('username', JSON.stringify(payload))
        },

        // getUserName(state, payload) {
        //     state.username = payload
        // },

    },
    getters: {},

    actions: {
        //储存是否是第一次加载的状态
        setCacheObjFirstLoad({commit},status){
            commit("setCacheObjFirstLoad", status);
        },
        //首页滚动条位置
        setCacheObjScollPostion({commit}, scollPostion){
            commit("setCacheObjScollPostion", scollPostion);
        },
        //是否到底部
        setCacheObjFinished({commit}, status){
            commit("setCacheObjFinished", status);
        },
        //是否是正在加载中
        setCacheObjLoading({commit}, status){
            commit("setCacheObjLoading", status);
        },
        //储存当前页数
        setCacheObjPagenum({commit},num){
            commit("setCacheObjPagenum", num);
        },
        //储存当前条数
        setCacheObjTotal({commit},total){
            commit("setCacheObjTotal", total);
        },
        
        syncUpdateUserInfo({ commit }) {
            console.log("www")
            return new Promise((resolve, reject) => {
                api.getUser().then(res => {
                    if (res.code == 0) {
                        commit("setName", res.data.name);
                        commit("setRoles", res.data.roles);
                        commit("setPosition", res.data.position);
                        commit("setUserId", res.data._id);
                        commit("setAccount", res.data.account);
                        commit("setUserInfo", res.data);
                    }
                    resolve(res)
                }).catch(error => {
                  reject(error)
                })
            })

            
        },
        syncGetProjectList({ commit }) {
          
            return new Promise((resolve, reject) => {
                api.getProjectList({req:{}}).then(res => {
                    if (res.code == 0) {
                        commit("setProjectList", res.data);
                        if (  res.data.length == 1){
                            console.log("name", res.data[0])
                            commit("setCurProject", res.data[0]);
                        }
                        
                    }
                    resolve(res)
                }).catch(error => {
                  reject(error)
                })
            })

            
        },


    },
    modules: {}
});